import {ChangeDetectionStrategy, Component, HostBinding, input, numberAttribute} from '@angular/core'

@Component({
  selector: 'cft-notification-bullet',
  standalone: true,
  imports: [],
  templateUrl: './notification-bullet.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: `
    @reference '../../../styles/app-reference.css';

    :host {
      --bullet-height: 1.125rem;
      @apply inline-flex shrink-0 grow-0 items-center justify-center rounded-full bg-vermillon-500;
      @apply text-center leading-none font-bold tracking-normal text-white;
      @apply h-(--bullet-height) min-w-(--bullet-height) px-[0.25rem] py-[0.125rem] text-[0.625rem];
    }

    :host(.small) {
      --bullet-height: 0.75rem;
      @apply px-[0.2rem] pt-0 pb-[0.1rem] text-[0.45rem] leading-[0];
    }
  `,
})
export class NotificationBulletComponent {
  amount = input.required({transform: numberAttribute})
  size = input<'default' | 'small'>('default')
  @HostBinding('attr.aria-hidden') ariaHidden = true
  @HostBinding('class.small') get isSmall() {
    return this.size() === 'small'
  }
}
